import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { LOGIN } from '@shared/helpers/routes';
import { useSelector, useDispatch } from 'react-redux';
import { onUserLogout } from '@shared/redux/actions';
import { getLastDollarRate } from '@shared/services/services';

import { ID_SITE, COLLEGEURL, ENV } from '@shared/conf/env';

import { Grid, useTheme } from '@mui/material';

import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import useWindowSize from '@shared/hooks/useWindowsSize';

import MobileMenu from './MobileMenu';

import HeaderLeft from './HeaderLeft';
import HeaderRight from './HeaderRight';
import HeaderModals from './HeaderModals';

import { sxHeader } from './styles';
import { getValidAccessToken } from '@shared/services/http/interceptor';
import { getUser } from '@shared/helpers/auth';

export const getSafeToken = async () => {
  if (getValidAccessToken) {
    return await getValidAccessToken();
  }

  const user = getUser();
  return user?.access_token || null;
};

const commonRoutes = {
  dev: 'https://dev-backoffice.viajestdh.com.ar/',
  tst: 'https://tst-backoffice.viajestdh.com.ar/',
  stg: 'https://stg-backoffice.viajestdh.com.ar/',
};

const routeMappings = {
  1: {
    ...commonRoutes,
    prd: 'https://backoffice.viajestdh.com.ar/',
  },
  default: {
    ...commonRoutes,
    prd: 'https://backoffice.gitcordoba.com/',
  },
};

export const Header = () => {
  const theme = useTheme();

  const ID_SITE_CONST = Number(ID_SITE);
  const { userToken, user } = useSelector(state => state.userInfo);
  const pageConfiguration = useSelector(store => store.pageConfiguration);
  const dispatch = useDispatch();
  const history = useHistory();
  const screenSize = useWindowSize();
  const location = useLocation();
  const [toggled, setToggled] = useState(true);
  const [openMenuAccount, setOpenMenuAccount] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isRegisteredModal, setIsRegisteredModal] = useState(false);
  const [isHoveringBO, setIsHoveringBO] = useState(false);
  const [isHoveringCO, setIsHoveringCO] = useState(false);

  const [bspAndGitDollarValue, setBspAndGitDollarValue] = useState(false);

  const loginHandler = () => {
    if (ID_SITE_CONST == 3 && !userToken) {
      window.open('https://git.app.pricenavigator.net/login/b2b');
    } else if (userToken) {
      dispatch(onUserLogout());
      history.push(LOGIN);
    } else {
      history.push(LOGIN);
    }
  };

  const applyRouteMappings = idSite => {
    const mappings = routeMappings[idSite] || routeMappings.default;
    return mappings[ENV];
  };

  const backofficeRedirect = async () => {
    const token = await getSafeToken();

    if (!token) return;

    const encode = btoa(token);
    window.open(`${applyRouteMappings(ID_SITE)}/login/${encode}`);
  };

  const fetchDollarGitAndBsp = async () => {
    try {
      let result = await getLastDollarRate();
      setBspAndGitDollarValue(result);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (pageConfiguration.site_functions.showDollarInfo) {
      fetchDollarGitAndBsp();
    }
  }, []);

  const collegeRedirect = () => {
    let url = COLLEGEURL;

    window.open(`${url}?token=${userToken}&email=${user.email}`);
  };
  const openAccountMenu = event => {
    setOpenMenuAccount(event.currentTarget);
  };
  const closeAccountMenu = () => {
    setOpenMenuAccount(null);
  };
  const onClickHandler = () => {
    setToggled(!toggled);
  };

  return (
    <>
      {pageConfiguration.id === 1 && <Grid sx={sxHeader.headerYellowRow} />}
      <Grid
        container
        sx={{
          background: theme.headerColor,
          height: { xs: '90px', lg: '110px' },
          px: { xs: '16px', md: '32px', lg: '116px' },
        }}
      >
        <HeaderLeft
          {...{
            pageConfiguration,
            history,
            screenSize,
          }}
        />

        <HeaderRight
          {...{
            pageConfiguration,
            userToken,
            user,
            loginHandler,
            openAccountMenu,
            openMenuAccount,
            closeAccountMenu,
            backofficeRedirect,
            setIsHoveringBO,
            isHoveringBO,
            collegeRedirect,
            setIsHoveringCO,
            isHoveringCO,
            onClickHandler,
          }}
        />
      </Grid>

      {/* Menú Mobile */}
      {!toggled && (
        <MobileMenu
          {...{
            toggled,
            onClickHandler,
            userToken,
            sxHeader,
            user,
            loginHandler,
            pageConfiguration,
            location,
            history,
            backofficeRedirect,
            setIsHoveringBO,
            isHoveringBO,
            collegeRedirect,
            isHoveringCO,
          }}
        />
      )}

      {/* Modales */}
      <HeaderModals
        {...{
          showModal,
          setShowModal,
          pageConfiguration,
          bspAndGitDollarValue,
          isRegisteredModal,
          setIsRegisteredModal,
        }}
      />
    </>
  );
};

export default Header;
